// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { WeaponTypeId } from '../tbs/weapon-type-id.js';


export class Weapon implements flatbuffers.IUnpackableObject<WeaponT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Weapon {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsWeapon(bb:flatbuffers.ByteBuffer, obj?:Weapon):Weapon {
  return (obj || new Weapon()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsWeapon(bb:flatbuffers.ByteBuffer, obj?:Weapon):Weapon {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Weapon()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

wtId():WeaponTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : WeaponTypeId.None;
}

ammo():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

ammops():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

maxAmmo():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

str():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

minRange():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

maxRange():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : -1;
}

ca():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

airOnly():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startWeapon(builder:flatbuffers.Builder) {
  builder.startObject(9);
}

static addWtId(builder:flatbuffers.Builder, wtId:WeaponTypeId) {
  builder.addFieldInt16(0, wtId, WeaponTypeId.None);
}

static addAmmo(builder:flatbuffers.Builder, ammo:number) {
  builder.addFieldInt16(1, ammo, -1);
}

static addAmmops(builder:flatbuffers.Builder, ammops:number) {
  builder.addFieldInt16(2, ammops, -1);
}

static addMaxAmmo(builder:flatbuffers.Builder, maxAmmo:number) {
  builder.addFieldInt16(3, maxAmmo, -1);
}

static addStr(builder:flatbuffers.Builder, str:number) {
  builder.addFieldInt16(4, str, -1);
}

static addMinRange(builder:flatbuffers.Builder, minRange:number) {
  builder.addFieldInt16(5, minRange, -1);
}

static addMaxRange(builder:flatbuffers.Builder, maxRange:number) {
  builder.addFieldInt16(6, maxRange, -1);
}

static addCa(builder:flatbuffers.Builder, ca:boolean) {
  builder.addFieldInt8(7, +ca, +false);
}

static addAirOnly(builder:flatbuffers.Builder, airOnly:boolean) {
  builder.addFieldInt8(8, +airOnly, +false);
}

static endWeapon(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createWeapon(builder:flatbuffers.Builder, wtId:WeaponTypeId, ammo:number, ammops:number, maxAmmo:number, str:number, minRange:number, maxRange:number, ca:boolean, airOnly:boolean):flatbuffers.Offset {
  Weapon.startWeapon(builder);
  Weapon.addWtId(builder, wtId);
  Weapon.addAmmo(builder, ammo);
  Weapon.addAmmops(builder, ammops);
  Weapon.addMaxAmmo(builder, maxAmmo);
  Weapon.addStr(builder, str);
  Weapon.addMinRange(builder, minRange);
  Weapon.addMaxRange(builder, maxRange);
  Weapon.addCa(builder, ca);
  Weapon.addAirOnly(builder, airOnly);
  return Weapon.endWeapon(builder);
}

unpack(): WeaponT {
  return new WeaponT(
    this.wtId(),
    this.ammo(),
    this.ammops(),
    this.maxAmmo(),
    this.str(),
    this.minRange(),
    this.maxRange(),
    this.ca(),
    this.airOnly()
  );
}


unpackTo(_o: WeaponT): void {
  _o.wtId = this.wtId();
  _o.ammo = this.ammo();
  _o.ammops = this.ammops();
  _o.maxAmmo = this.maxAmmo();
  _o.str = this.str();
  _o.minRange = this.minRange();
  _o.maxRange = this.maxRange();
  _o.ca = this.ca();
  _o.airOnly = this.airOnly();
}
}

export class WeaponT implements flatbuffers.IGeneratedObject {
constructor(
  public wtId: WeaponTypeId = WeaponTypeId.None,
  public ammo: number = -1,
  public ammops: number = -1,
  public maxAmmo: number = -1,
  public str: number = -1,
  public minRange: number = -1,
  public maxRange: number = -1,
  public ca: boolean = false,
  public airOnly: boolean = false
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return Weapon.createWeapon(builder,
    this.wtId,
    this.ammo,
    this.ammops,
    this.maxAmmo,
    this.str,
    this.minRange,
    this.maxRange,
    this.ca,
    this.airOnly
  );
}
}
